import React from 'react';
import PropTypes from 'prop-types';

const UpArrow = ({color = 'currentColor', width}) => {
  return (
    <svg width={width} viewBox="0 0 1024 1024">
      <path fill={color} d="M104.704 685.248a64 64 0 0 0 90.496 0l316.8-316.8 316.8 316.8a64 64 0 0 0 90.496-90.496L557.248 232.704a64 64 0 0 0-90.496 0L104.704 594.752a64 64 0 0 0 0 90.496z"/>
    </svg>
  )
}

UpArrow.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string
};

export default UpArrow;
